module.exports = __webpack_public_path__ + "static/media/01B.69ce6306.png";